var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.155,
    height: 17.139,
    viewBox: "0 0 17.155 17.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M-1264,240.277a.717.717,0,0,1,.555-.7l3.107-.716a.72.72,0,0,1,.821.415l1.435,3.345a.716.716,0,0,1-.207.837l-1.81,1.481a11.072,11.072,0,0,0,5.293,5.293l1.481-1.81a.717.717,0,0,1,.837-.206l3.345,1.434a.725.725,0,0,1,.419.824l-.717,3.107a.716.716,0,0,1-.7.556A13.859,13.859,0,0,1-1264,240.277Zm12.469,5.749a5.282,5.282,0,0,0-1.49-2.863,5.29,5.29,0,0,0-2.871-1.487.554.554,0,0,1-.454-.648.564.564,0,0,1,.649-.454,6.412,6.412,0,0,1,3.474,1.8,6.385,6.385,0,0,1,1.8,3.465.56.56,0,0,1-.462.647.7.7,0,0,1-.1.008A.557.557,0,0,1-1251.53,246.026Zm3.57-.17a9.387,9.387,0,0,0-2.651-5.1,9.464,9.464,0,0,0-5.114-2.642.564.564,0,0,1-.462-.649.56.56,0,0,1,.644-.456,10.577,10.577,0,0,1,5.722,2.959,10.532,10.532,0,0,1,2.966,5.707.552.552,0,0,1-.458.639.681.681,0,0,1-.1.007A.558.558,0,0,1-1247.96,245.856Z",
    transform: "translate(1264 -236.999)",
    fill: "#4affbc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallNew);
export default __webpack_public_path__ + "static/media/call-new.fd5768cc0db17021bdc5177a94c683ac.svg";
export { ForwardRef as ReactComponent };